import { Illustration, Layout, TheVoice } from "@obs/base";
import { Error404Illustration } from "@obs/icons";
import { createFileRoute } from "@tanstack/react-router";
import { useIntl } from "react-intl";

export const Route = createFileRoute("/404")({
	component: RouteComponent,
});

function RouteComponent() {
	const { formatMessage } = useIntl();

	return (
		<Layout.Container maxWidth="sm">
			<Illustration illustration={Error404Illustration} />
			<TheVoice>
				{formatMessage({
					id: "trip_tracking.not_found.voice",
					defaultMessage: "Slight problem...",
				})}
			</TheVoice>
		</Layout.Container>
	);
}
